import {
  AutomaticReminderSubmit,
  BillReminderDto,
  BillReminderRequest,
  BillReminderResponse,
  BillReminderSearchResponse,
  BillStornoSearchRequest
} from 'ts-types/api.types';
import axios from 'services/http';
import { CancelTokenSource } from 'axios';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/bill-reminders`;

export const getAllBillRemindersByBillId = (billId: number, source: CancelTokenSource): Promise<Array<BillReminderDto>> => {
  return axios
      .get(`${apiUri}/bill/${billId}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const searchBills = (billStornoSearchRequest: Partial<BillStornoSearchRequest>, source: CancelTokenSource): Promise<Array<BillReminderSearchResponse>> => {
  return axios
      .post(`${apiUri}/search`, billStornoSearchRequest,{ cancelToken: source.token })
      .then(response => response.data);
};

export const remindBills = (billReminderRequest: Partial<BillReminderRequest>, source: CancelTokenSource): Promise<Array<BillReminderResponse>> => {
  return axios
      .post(`${apiUri}/remind-bills`, billReminderRequest, { cancelToken: source.token })
      .then(response => response.data);
};

export const automaticRemind = (automaticReminderSubmit: Partial<AutomaticReminderSubmit>, source: CancelTokenSource): Promise<Array<BillReminderResponse>> => {
  return axios
      .post(`${apiUri}/automatic-remind`, automaticReminderSubmit, { cancelToken: source.token })
      .then(response => response.data);
};

export const getBillReminderPdfUrl = (pdfId: string, pdfName: string): string => {
  return `${baseUrl}/1fb99b8cd1d94cbdba2a7f6347861e09/${pdfId}/${pdfName}`
};
